// extracted by mini-css-extract-plugin
module.exports = {"box":"index-module_box_3PQXj","switchStyle":"index-module_switchStyle_18utP"};